<template>
  <QPaginatedSearchDropdown :key="resetKey" :value="value" :list-getter="getLeadTypeListFromFilter" :filter="filter"
    :min-search-char-limit="0" :allow-create="allowCreate && !SupplierReadonly" :externaledit="externaledit"
    :clearable="clearable" :multiple="multiple" :returnobject="returnobject" :disabled="disabled"
    :loading="createLoading || loading" valuekey="Id" textkey="Name"
    :label="label ? label : $t('servicesystem.common_objects.lead.lead_type')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.lead.lead_type_search_field_label')"
    :rules="rules" @input="e => $emit('input', e)" @change="e => $emit('change', e)" @create="e => createNew(e)"
    @FocusState="e => $emit('FocusState', e)">
    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">mdi-brightness-auto</v-icon>
    </template>

    <template v-if="!multiple" v-slot:selection="{ item }">
      <v-chip small style="border-radius: 4px;">
        <span class="text-truncate">
          {{ item.Name }}
        </span>
      </v-chip>
    </template>

  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "LeadTypeSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    rules: Array,
    allowCreate: Boolean,
    hideIcon: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
      createLoading: false,
      resetKey: 1,
    };
  },

  methods: {
    async createNew({ value, onComplete }) {
      this.createLoading = true;
      const dto = { Name: value };
      clientAPI.methods.createLeadType(dto)
        .then(async response => {
          var val = this.returnobject ? response : response.Id;
          if (this.multiple) {
            val = [...this.value, val];
          }
          this.$emit('input', val);
          this.$emit('change', val);
          await onComplete();
          //reset required to force reload while in editmode
          if (this.externaledit) {
            this.resetKey++;
          }
        })
        .finally(() => {
          this.createLoading = false;
        });
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>